import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { PopularDevices } from '../components/PopularDevices';
import { TopSellingBrands } from '../components/TopSellingBrands';
import { TopSellingModels } from '../components/TopSellingModels';
import { SustainabilityCommitment } from '../components/SustainabilityCommitment';
import { CommunityStories } from '../components/CommunityStories';
import { BlogSection } from '../components/BlogSection';
export const HomePage = () => {
  return <main className="w-full" data-id="element-2856">
      <HeroSection data-id="element-2857" />
      <div className="container mx-auto px-4 py-8" data-id="element-2858">
        <PopularDevices data-id="element-2859" />
      </div>
      <TopSellingBrands data-id="element-2860" />
      <TopSellingModels data-id="element-2861" />
      <SustainabilityCommitment data-id="element-2862" />
      <CommunityStories data-id="element-2863" />
      <BlogSection data-id="element-2864" />
    </main>;
};